module.exports = __webpack_public_path__ + "static/media/logo.53582c61.svg";